
// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import Header from "../../components/Header/Header";
// import Footer from "../../components/Footer/Footer";
// import RelatedBlogs from "./RelatedBlogs";import DOMPurify from "dompurify";
// import {
//   FiArrowLeft,
//   FiCalendar,
//   FiUser,
// } from "react-icons/fi";
// import "./Blog.css";

// const API_BASE_URL =
//   "https://astrologicalsolutions.astrologicalsolutions.in";

// const createSectionId = (title, index) => {
//   const slug = (title || "section")
//     .toLowerCase()
//     .replace(/[^a-z0-9]+/g, "-")
//     .replace(/^-+|-+$/g, "");

//   return `blog-section-${index}-${slug}`;
// };

// const stripHtml = (content = "") =>
//   content.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

// /* Convert blog content into sections */
// const parseBlogContent = (content) => {
//   if (!content || typeof content !== "string") {
//     return [];
//   }

//   // HTML content with headings
//   if (/<h[1-6][\s>]/i.test(content)) {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(content, "text/html");
//     const sections = [];
//     let current = null;

//     Array.from(doc.body.children).forEach((element) => {
//       if (/^H[1-6]$/.test(element.tagName)) {
//         current = {
//           title: element.textContent.trim(),
//           blocks: [],
//         };
//         sections.push(current);
//       } else if (current) {
//         current.blocks.push({
//           type: "html",
//           content: element.outerHTML,
//         });
//       } else if (element.textContent.trim()) {
//         sections.push({
//           title: "",
//           blocks: [
//             {
//               type: "html",
//               content: element.outerHTML,
//             },
//           ],
//         });
//       }
//     });

//     return sections;
//   }

//   // Plain text / Markdown content
//   const lines = content.split(/\r?\n/);
//   const sections = [];

//   let current = {
//     title: "",
//     blocks: [],
//   };

//   const isHeading = (line) => {
//     const text = line.replace(/^#{1,6}\s+/, "").trim();

//     if (!text || text.length > 100) return false;

//     if (/^#{1,6}\s+/.test(line)) return true;

//     return /^(introduction|conclusion|key highlights|frequently asked questions|faqs|what\b|why\b|how\b|which\b|when\b|where\b|types of\b|benefits of\b|meaning of\b|history of\b|final thoughts\b|tips for\b|how to\b)/i.test(
//       text
//     );
//   };

//   lines.forEach((line) => {
//     const trimmed = line.trim();

//     if (!trimmed) return;

//     if (isHeading(trimmed)) {
//       if (current.title || current.blocks.length) {
//         sections.push(current);
//       }

//       current = {
//         title: trimmed.replace(/^#{1,6}\s+/, ""),
//         blocks: [],
//       };
//     } else {
//       current.blocks.push({
//         type: "text",
//         content: trimmed,
//       });
//     }
//   });

//   if (current.title || current.blocks.length) {
//     sections.push(current);
//   }

//   return sections;
// };

// const BlogDetails = () => {
//   const { id } = useParams();

//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const controller = new AbortController();

//     const fetchBlogDetails = async () => {
//       setLoading(true);
//       setError("");
//       setBlog(null);

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/api/v1/blogs/public/${encodeURIComponent(id)}`,
//           {
//             method: "GET",
//             headers: {
//               Accept: "application/json",
//             },
//             signal: controller.signal,
//             cache: "no-store",
//           }
//         );

//         const result = await response.json();

//         if (!response.ok || result.success === false) {
//           throw new Error(
//             result.message || "Unable to load this blog."
//           );
//         }

//         const blogData =
//           result?.data?.blog ||
//           result?.data?.data ||
//           result?.data;

//         if (
//           !blogData ||
//           Array.isArray(blogData) ||
//           !blogData.title
//         ) {
//           throw new Error("Blog details were not found.");
//         }

//         if (
//           String(blogData.status || "").toLowerCase() !==
//           "published"
//         ) {
//           throw new Error(
//             "This blog is not available publicly."
//           );
//         }

//         setBlog(blogData);
//       } catch (err) {
//         if (err.name !== "AbortError") {
//           setError(
//             err.message ||
//               "Something went wrong while loading the blog."
//           );
//         }
//       } finally {
//         if (!controller.signal.aborted) {
//           setLoading(false);
//         }
//       }
//     };

//     if (id) {
//       fetchBlogDetails();
//     } else {
//       setError("Blog ID is missing.");
//       setLoading(false);
//     }

//     return () => controller.abort();
//   }, [id]);

//   const formatDate = (date) => {
//     if (!date) return "";

//     const parsedDate = new Date(date);

//     if (Number.isNaN(parsedDate.getTime())) {
//       return "";
//     }

//     return parsedDate.toLocaleDateString("en-IN", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });
//   };

//   const readingTime = (content) => {
//     const text = stripHtml(content);

//     return Math.max(
//       1,
//       Math.ceil((text ? text.split(/\s+/).length : 0) / 200)
//     );
//   };

//   if (loading) {
//     return (
//       <>
//         <Header />
//         <main className="blog-details-container">
//           <div className="blog-details-message">
//             <p>Loading article...</p>
//           </div>
//         </main>
//         <Footer />
//       </>
//     );
//   }

//   if (error || !blog) {
//     return (
//       <>
//         <Header />
//         <main className="blog-details-container">
//           <div className="blog-details-message">
//             <h2>Blog Not Available</h2>
//             <p>{error || "This article could not be found."}</p>
//             <Link to="/blog" className="back-to-blogs">
//               <FiArrowLeft /> Back to Blogs
//             </Link>
//           </div>
//         </main>
//         <Footer />
//       </>
//     );
//   }

//   const sections = parseBlogContent(blog.content);

//   const highlights = sections
//     .map((section, index) => ({
//       ...section,
//       originalIndex: index,
//     }))
//     .filter((section) => section.title);

//   return (
//     <>
//       <Header />

//       <main className="blog-details-container">
//         <div className="blog-details-inner">

//           {/* Breadcrumb */}
//           <nav className="blog-breadcrumb" aria-label="Breadcrumb">
//             <Link to="/">Home</Link>
//             <span className="breadcrumb-separator">›</span>
//             <Link to="/blog">Blogs</Link>

//             {blog.category && (
//               <>
//                 <span className="breadcrumb-separator">›</span>
//                 <span className="breadcrumb-category">
//                   {blog.category}
//                 </span>
//               </>
//             )}

//             <span className="breadcrumb-separator">›</span>
//             <span
//               className="breadcrumb-current"
//               aria-current="page"
//             >
//               {blog.title}
//             </span>
//           </nav>

//           {/* Main image: layout preserved */}
//           {blog.image && (
//             <div className="blog-article-image-wrapper">
//               <img
//                 src={blog.image}
//                 alt={blog.title}
//                 className="blog-article-image"
//               />
//             </div>
//           )}

//           {/* Author, date and reading time */}
//           <div className="blog-article-meta">
//             {blog.author && (
//               <span>
//                 <FiUser />
//                 {typeof blog.author === "string"
//                   ? blog.author
//                   : blog.author.name || "Astro Logical Solutions"}
//               </span>
//             )}

//             {blog.createdAt && (
//               <span>
//                 <FiCalendar />
//                 {formatDate(blog.createdAt)}
//               </span>
//             )}

//             <span>{readingTime(blog.content)} min read</span>
//           </div>

//           {/* Article and Key Highlights */}
//           <div className="blog-content-layout">

//             <article className="blog-article-body">
//               <h1 className="blog-detail-title">
//                 {blog.title}
//               </h1>

//               {blog.excerpt && (
//                 <p className="blog-detail-excerpt">
//                   {blog.excerpt}
//                 </p>
//               )}

//               {sections.length > 0 ? (
//                 sections.map((section, index) => (
//                   <section
//                     className="blog-content-section"
//                     id={createSectionId(section.title, index)}
//                     key={`${section.title}-${index}`}
//                   >
//                     {section.title && <h2>{section.title}</h2>}

//                     {section.blocks.map((block, blockIndex) => (
//                       <div
//                         className="blog-section-paragraph"
//                         key={blockIndex}
//                       >
//                         {block.type === "html" ? (
//                           <div
//                             dangerouslySetInnerHTML={{
//                               __html: block.content,
//                             }}
//                           />
//                         ) : (
//                           <p>{block.content}</p>
//                         )}
//                       </div>
//                     ))}
//                   </section>
//                 ))
//               ) : (
//                 <div className="blog-article-content">
//                   {blog.content ||
//                     "Full article content is not available."}
//                 </div>
//               )}

//               <Link to="/blog" className="back-to-blogs">
//                 <FiArrowLeft /> Back to All Blogs
//               </Link>
//             </article>

//             {/* Right-side Key Highlights */}
//             <aside className="blog-highlights">
//               <h2>Key Highlights</h2>

//               {highlights.length > 0 ? (
//                 <nav aria-label="Article key highlights">
//                   {highlights.map((section) => (
//                     <a
//                       href={`#${createSectionId(
//                         section.title,
//                         section.originalIndex
//                       )}`}
//                       key={`${section.title}-${section.originalIndex}`}
//                     >
//                       <span className="highlight-diamond">◆</span>
//                       <span>{section.title}</span>
//                     </a>
//                   ))}
//                 </nav>
//               ) : (
//                 <p className="blog-highlights-empty">
//                   Add headings to your blog content to display
//                   Key Highlights here.
//                 </p>
//               )}
//             </aside>

//           </div>

//           {/* Bottom CTA */}
//           <div className="blog-details-footer">
//             <p>Enjoyed this article?</p>
//             <Link to="/blog" className="back-to-blogs">
//               Explore More Articles
//             </Link>
//           </div>

//           {/* Related Blogs component */}
//           <RelatedBlogs currentBlogId={blog.id} />

//         </div>
//       </main>

//       <Footer />
//     </>
//   );
// };

// export default BlogDetails;



import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import RelatedBlogs from "./RelatedBlogs";

import DOMPurify from "dompurify";

import {
  FiArrowLeft,
  FiCalendar,
  FiUser,
} from "react-icons/fi";

import "./Blog.css";

const API_BASE_URL =
  "https://astrologicalsolutions.astrologicalsolutions.in";

/* Create unique IDs for article headings */
const createSectionId = (title, index) => {
  const slug = (title || "section")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `blog-section-${index}-${slug}`;
};

/* Remove HTML tags for reading-time calculation */
const stripHtml = (content = "") => {
  if (typeof content !== "string") {
    return "";
  }

  const doc = new DOMParser().parseFromString(
    content,
    "text/html"
  );

  return (doc.body.textContent || "")
    .replace(/\s+/g, " ")
    .trim();
};

/*
  Parse blog HTML into sections.

  Supports:
  - HTML paragraphs
  - H1-H6 headings
  - Bold and italic text
  - Ordered and unordered lists
  - Tables, images and links
  - Plain text content
*/
const parseBlogContent = (content) => {
  if (!content || typeof content !== "string") {
    return [];
  }

  const trimmedContent = content.trim();

  if (!trimmedContent) {
    return [];
  }

  /*
    IMPORTANT:
    Check for any HTML tag, not only heading tags.
    This fixes the issue where <p> and <strong>
    were displayed as plain text.
  */
  const containsHtml = /<\/?[a-z][^>]*>/i.test(
    trimmedContent
  );

  if (containsHtml) {
    const parser = new DOMParser();

    const doc = parser.parseFromString(
      trimmedContent,
      "text/html"
    );

    const elements = Array.from(doc.body.children);

    const hasHeadings = elements.some((element) =>
      /^H[1-6]$/.test(element.tagName)
    );

    /*
      If the content contains no headings,
      render the complete HTML as one article section.
    */
    if (!hasHeadings) {
      return [
        {
          title: "",
          blocks: [
            {
              type: "html",
              content: doc.body.innerHTML,
            },
          ],
        },
      ];
    }

    const sections = [];

    let currentSection = null;
    let preHeadingBlocks = [];

    elements.forEach((element) => {
      const tagName = element.tagName;

      if (/^H[1-6]$/.test(tagName)) {
        /*
          Keep content that appears before the first
          heading instead of accidentally losing it.
        */
        if (preHeadingBlocks.length > 0) {
          sections.push({
            title: "",
            blocks: preHeadingBlocks,
          });

          preHeadingBlocks = [];
        }

        currentSection = {
          title: element.textContent.trim(),
          blocks: [],
        };

        sections.push(currentSection);
      } else {
        const html = element.outerHTML;

        if (currentSection) {
          currentSection.blocks.push({
            type: "html",
            content: html,
          });
        } else {
          preHeadingBlocks.push({
            type: "html",
            content: html,
          });
        }
      }
    });

    if (preHeadingBlocks.length > 0) {
      sections.unshift({
        title: "",
        blocks: preHeadingBlocks,
      });
    }

    return sections;
  }

  /*
    Plain text fallback.
    Supports headings written as Markdown
    and common standalone heading patterns.
  */
  const lines = trimmedContent.split(/\r?\n/);

  const sections = [];

  let currentSection = {
    title: "",
    blocks: [],
  };

  const isHeading = (line) => {
    const text = line
      .replace(/^#{1,6}\s+/, "")
      .trim();

    if (!text || text.length > 100) {
      return false;
    }

    if (/^#{1,6}\s+/.test(line)) {
      return true;
    }

    return /^(introduction|conclusion|key highlights|frequently asked questions|faqs|what\b|why\b|how\b|which\b|when\b|where\b|types of\b|benefits of\b|meaning of\b|history of\b|final thoughts\b|tips for\b|how to\b)/i.test(
      text
    );
  };

  lines.forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed) {
      return;
    }

    if (isHeading(trimmed)) {
      if (
        currentSection.title ||
        currentSection.blocks.length > 0
      ) {
        sections.push(currentSection);
      }

      currentSection = {
        title: trimmed.replace(/^#{1,6}\s+/, ""),
        blocks: [],
      };
    } else {
      currentSection.blocks.push({
        type: "text",
        content: trimmed,
      });
    }
  });

  if (
    currentSection.title ||
    currentSection.blocks.length > 0
  ) {
    sections.push(currentSection);
  }

  return sections;
};

/* Blog Details Component */
const BlogDetails = () => {
  const { id } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* Fetch published blog details */
  useEffect(() => {
    const controller = new AbortController();

    const fetchBlogDetails = async () => {
      setLoading(true);
      setError("");
      setBlog(null);

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/v1/blogs/public/${encodeURIComponent(
            id
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
            cache: "no-store",
          }
        );

        const result = await response.json();

        if (!response.ok || result.success === false) {
          throw new Error(
            result.message || "Unable to load this blog."
          );
        }

        const blogData =
          result?.data?.blog ||
          result?.data?.data ||
          result?.data;

        if (
          !blogData ||
          Array.isArray(blogData) ||
          !blogData.title
        ) {
          throw new Error(
            "Blog details were not found."
          );
        }

        if (
          String(blogData.status || "").toLowerCase() !==
          "published"
        ) {
          throw new Error(
            "This blog is not available publicly."
          );
        }

        setBlog(blogData);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(
            err.message ||
              "Something went wrong while loading the blog."
          );
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    if (id) {
      fetchBlogDetails();
    } else {
      setError("Blog ID is missing.");
      setLoading(false);
    }

    return () => controller.abort();
  }, [id]);

  /* Format publication date */
  const formatDate = (date) => {
    if (!date) {
      return "";
    }

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) {
      return "";
    }

    return parsedDate.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  /* Calculate reading time */
  const readingTime = (content) => {
    const text = stripHtml(content);

    return Math.max(
      1,
      Math.ceil(
        (text ? text.split(/\s+/).length : 0) / 200
      )
    );
  };

  /* Loading state */
  if (loading) {
    return (
      <>
        <Header />

        <main className="blog-details-container">
          <div className="blog-details-message">
            <p>Loading article...</p>
          </div>
        </main>

        <Footer />
      </>
    );
  }

  /* Error state */
  if (error || !blog) {
    return (
      <>
        <Header />

        <main className="blog-details-container">
          <div className="blog-details-message">
            <h2>Blog Not Available</h2>

            <p>
              {error || "This article could not be found."}
            </p>

            <Link
              to="/blog"
              className="back-to-blogs"
            >
              <FiArrowLeft />
              Back to Blogs
            </Link>
          </div>
        </main>

        <Footer />
      </>
    );
  }

  const sections = parseBlogContent(blog.content);

  /* Extract article headings for Key Highlights */
  const highlights = sections
    .map((section, index) => ({
      ...section,
      originalIndex: index,
    }))
    .filter((section) => section.title);

  return (
    <>
      <Header />

      <main className="blog-details-container">
        <div className="blog-details-inner">

          {/* Breadcrumb */}
          <nav
            className="blog-breadcrumb"
            aria-label="Breadcrumb"
          >
            <Link to="/">Home</Link>

            <span className="breadcrumb-separator">
              ›
            </span>

            <Link to="/blog">Blogs</Link>

            {blog.category && (
              <>
                <span className="breadcrumb-separator">
                  ›
                </span>

                <span className="breadcrumb-category">
                  {blog.category}
                </span>
              </>
            )}

            <span className="breadcrumb-separator">
              ›
            </span>

            <span
              className="breadcrumb-current"
              aria-current="page"
            >
              {blog.title}
            </span>
          </nav>

          {/* Main Blog Image */}
          {blog.image && (
            <div className="blog-article-image-wrapper">
              <img
                src={blog.image}
                alt={blog.title}
                className="blog-article-image"
                loading="eager"
              />
            </div>
          )}

          {/* Author, Date and Reading Time */}
          <div className="blog-article-meta">
            {blog.author && (
              <span>
                <FiUser />

                {typeof blog.author === "string"
                  ? blog.author
                  : blog.author.name ||
                    "Astro Logical Solutions"}
              </span>
            )}

            {blog.createdAt && (
              <span>
                <FiCalendar />
                {formatDate(blog.createdAt)}
              </span>
            )}

            <span>
              {readingTime(blog.content)} min read
            </span>
          </div>

          {/* Article and Key Highlights */}
          <div className="blog-content-layout">

            {/* Main Article */}
            <article className="blog-article-body">

              <h1 className="blog-detail-title">
                {blog.title}
              </h1>

              {blog.excerpt && (
                <div
                  className="blog-detail-excerpt blog-rendered-html"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      blog.excerpt
                    ),
                  }}
                />
              )}

              {/* Complete Blog Content */}
              {sections.length > 0 ? (
                sections.map((section, index) => (
                  <section
                    className="blog-content-section"
                    id={createSectionId(
                      section.title,
                      index
                    )}
                    key={`${section.title}-${index}`}
                  >
                    {section.title && (
                      <h2>{section.title}</h2>
                    )}

                    {section.blocks.map(
                      (block, blockIndex) => (
                        <div
                          className="blog-section-paragraph"
                          key={blockIndex}
                        >
                          {block.type === "html" ? (
                            <div
                              className="blog-rendered-html"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  block.content
                                ),
                              }}
                            />
                          ) : (
                            <p>{block.content}</p>
                          )}
                        </div>
                      )
                    )}
                  </section>
                ))
              ) : (
                <div className="blog-article-content">
                  Full article content is not available.
                </div>
              )}

              {/* Back to Blogs */}
              <Link
                to="/blog"
                className="back-to-blogs"
              >
                <FiArrowLeft />
                Back to All Blogs
              </Link>

            </article>

            {/* Right-side Key Highlights */}
            <aside className="blog-highlights">
              <h2>Key Highlights</h2>

              {highlights.length > 0 ? (
                <nav aria-label="Article key highlights">
                  {highlights.map((section) => (
                    <a
                      href={`#${createSectionId(
                        section.title,
                        section.originalIndex
                      )}`}
                      key={`${section.title}-${section.originalIndex}`}
                    >
                      <span className="highlight-diamond">
                        ◆
                      </span>

                      <span>{section.title}</span>
                    </a>
                  ))}
                </nav>
              ) : (
                <p className="blog-highlights-empty">
                  Add headings to your blog content to
                  display Key Highlights here.
                </p>
              )}
            </aside>

          </div>

          {/* Bottom CTA */}
          <div className="blog-details-footer">
            <p>Enjoyed this article?</p>

            <Link
              to="/blog"
              className="back-to-blogs"
            >
              Explore More Articles
            </Link>
          </div>

          {/* Related Blogs */}
          <RelatedBlogs currentBlogId={blog.id} />

        </div>
      </main>

      <Footer />
    </>
  );
};

export default BlogDetails;